import React from 'react';
import getDoc from '../../qdoc';
import * as d3 from 'd3';

class BarChart extends React.Component {
  constructor(props) {
    super(props);
    this.getCube = getDoc.then(doc => {
      return doc.createSessionObject({
        qInfo: {
          qType: "visualization"
        },
        qHyperCubeDef: { 
          qStateName: this.props.qStateName,          
          qDimensions: [{
            qDef: {
              qFieldDefs: [this.props.dimension],
              qSortCriterias: [{ 
                qSortByAscii: 1
              }]
            },
            qNullSuppression: true
          }],
          qMeasures: [{
            qDef: {
              qDef: this.props.measure
            },
            qSortBy: {
              qSortByNumeric: -1
            }
          }],
          qInterColumnSortOrder: this.props.sortorder
        }
      });
    });

    this.state = {
      data: [],
    }

    $(window).resize(() => {
      this.draw();
    });
  }

  componentDidMount() { 
    this.initialize();   
    this.update();
    this.getCube.then(cube => {
      cube.on('changed', () => {
        this.update();
      });
    });
  }

  componentWillReceiveProps(props) {
    this.getCube.then(cube => {
      cube.applyPatches([{
        qOp: "replace",
        qPath: "/qHyperCubeDef/qMeasures/0/qDef/qDef",
        qValue: JSON.stringify(this.props.measure)
      }]);
    });
  }
  
  shouldComponentUpdate() {
    return false; // This prevents future re-renders of this component
  }

  update() {
    this.getHyperCubeData();
  }

  getHyperCubeData() {
    this.getCube.then(cube => {
      cube.getHyperCubeData("/qHyperCubeDef", [{
        qTop: 0, 
        qLeft: 0, 
        qHeight: 180, 
        qWidth: 2
      }]).then(cubeData => {
        this.setState({data: cubeData[0].qMatrix});
        this.draw();
      });
    });
  }

  selectRow(elnum) {
    this.getCube.then(cube => {
      cube.selectHyperCubeValues('/qHyperCubeDef', 0, [elnum], true);
    });
  }

  initialize() {
    this.svg = d3.select(this.refs['svg']);
    this.g = this.svg.append('g');
    this.xAxis = this.g.append('g');
    this.yAxis = this.g.append('g');
  }

  draw() {
    this.state.data = this.state.data.map(d => {
      d[0].qText = d[0].qIsOtherCell ? "Others" : d[0].qText; return d;
    });

    this.svg.attr('width', this.state.data.length * 32);

    //sizing
    let margin = {top: this.props.topMargin, right:0 , bottom: this.props.bottomMargin, left:0 },
      width = this.refs['svg'].getBoundingClientRect().width - margin.left - margin.right,
      height = this.refs['svg'].getBoundingClientRect().height - margin.top - margin.bottom;
    //transforms

    this.g.attr('transform', `translate(${margin.left},${margin.top})`);
    //scales
    this.xScale = d3.scaleBand()
      .domain(this.state.data.map(d => { return d[0].qText; }))  
      .range([0, this.state.data.length * 32]).paddingInner(0.25);      
    this.yScale = d3.scaleLinear()
      .domain([0, d3.max(this.state.data, d => { return d[1].qNum; })])
      .range([height, 0]);
         
    this.xAxis
      .attr("transform", `translate(0,${height})`)
      .call(d3.axisBottom(this.xScale).tickSize(0))
      .selectAll("text")
      // .style("text-anchor", "start")
      // .attr("x", "-" + margin.left)
      //.call(this.wrap, this.xScale.bandwidth());

    let bars = this.g.selectAll(".bar")
      .data(this.state.data);
    bars
      .attr('y', height)
      .attr('height', 0)
      .attr('x', d => { return this.xScale(d[0].qText); })
      .attr('width', this.xScale.bandwidth())
      .transition()
      .attr('y', d => { return this.yScale(d[1].qNum) })
      .attr('height', d => { return height - this.yScale(d[1].qNum); });
    bars
      .enter().append('rect')
      .attr('class', 'bar')
      .attr('fill', '#004154')
      .attr('y', height)
      .attr('x', d => { return this.xScale(d[0].qText); })
      .attr('width', this.xScale.bandwidth())
      .on('click', (d, i, nodes) => {
        this.selectRow(d[0].qElemNumber);
      })
      .transition()
      .attr('y', d => { return this.yScale(d[1].qNum) })
      .attr('height', d => { return height - this.yScale(d[1].qNum); });
    bars.exit().remove();

    let values = this.g.selectAll(".value-label")
      .data(this.state.data);

    values
      .attr('transform', d => { return `rotate(-90 ${this.xScale(d[0].qText)} ${this.yScale(d[1].qNum)})` })
      .attr('x', d => { return this.xScale(d[0].qText) + 4; })
      .attr('y', d => { return this.yScale(d[1].qNum) + this.xScale.bandwidth()/1.5; })
      .text(d => { return d[1].qText; });
    values
      .enter().append('text')
      .attr('class', 'value-label')
      .attr('text-anchor', 'start')
      .attr('font-size', '10')
      .attr('transform', d => { return `rotate(-90 ${this.xScale(d[0].qText)} ${this.yScale(d[1].qNum)})` })
      .attr('x', d => { return this.xScale(d[0].qText) + 4; })
      .attr('y', d => { return this.yScale(d[1].qNum) + this.xScale.bandwidth()/1.5; })
      .text(d => { return d[1].qText; });
    values.exit().remove();
  }

  wrap (text, width) {
    text.each(function() {
      var breakChars = ['/', '&', '-'],
        text = d3.select(this),
        textContent = text.text(),
        spanContent;
      breakChars.forEach(char => {
        // Add a space after each break char for the function to use to determine line breaks
        textContent = textContent.replace(char, char + ' ');
      });
      var words = textContent.split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        numOfBreaks = 0,
        lineHeight = 1.1, // ems
        x = text.attr('x'),
        y = text.attr('y'),
        dy = parseFloat(text.attr('dy') || 0),
        tspan = text.text(null).append('tspan').attr('x', x).attr('y', y).attr('dy', dy + 'em');
      while (word = words.pop()) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          spanContent = line.join(' ');
          breakChars.forEach(char => {
            // Remove spaces trailing breakChars that were added above
            spanContent = spanContent.replace(char + ' ', char);
          });
          tspan.text(spanContent);
          line = [word];
          tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy', ++lineNumber * lineHeight + dy + 'em').text(word);
          ++numOfBreaks;
        }
      }
      text.selectAll('tspan').attr('y', -0.5 * (numOfBreaks) + 'em');
    });
  }

  changeMeasure(event, i) {
    this.getCube.then(cube => {
      cube.applyPatches([{
        qOp: "replace",
        qPath: "/qHyperCubeDef/qMeasures/0/qDef/qDef",
        qValue: JSON.stringify(this.props.measure)
      }]).then(() => {
        this.setState({ updating: false, sortColumn: i });
      });
    });
  }

  render() {
    return (
      <svg ref="svg" style={{height: '100%'}}/>
    );
  }
}
BarChart.defaultProps = {bottomMargin: 30, topMargin: 30};

export default BarChart;


// WEBPACK FOOTER //
// ./components/Barchart/vertical.js